// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum ValueType {
  None = 0,
  String = 1,
  Number = 2,
  Boolean = 3,
  Json = 4
}
